var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content evl-page" },
    [
      _c(
        "div",
        { staticClass: "evl-main-tabs-card row-data" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "sk-tabs evl-main-tabs",
              attrs: { type: "card" },
              model: {
                value: _vm.mainTab,
                callback: function ($$v) {
                  _vm.mainTab = $$v
                },
                expression: "mainTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "EVALUATION" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "evl-main-tab-item" }, [
                      _c("i", { staticClass: "el-icon-edit-outline" }),
                      _vm._v(" Nhận xét\n          "),
                    ]),
                  ]),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { name: "CATEGORY_TEMPLATES" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "evl-main-tab-item" }, [
                      _c("i", { staticClass: "el-icon-collection" }),
                      _vm._v(" Mẫu nhận xét\n          "),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mainTab === "EVALUATION",
              expression: "mainTab === 'EVALUATION'",
            },
          ],
        },
        [
          _c("div", { staticClass: "evl-toolbar-card row-data" }, [
            _c(
              "div",
              {
                staticClass: "evl-toolbar-section evl-toolbar-section--filter",
              },
              [
                _vm._m(0),
                _c(
                  "el-form",
                  {
                    ref: "searchFormRef",
                    staticClass: "evl-form-grid",
                    attrs: {
                      model: _vm.searchRequest,
                      "label-position": "top",
                    },
                  },
                  [
                    !_vm.isPeriodicTab
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "evl-form-item",
                            attrs: { label: _vm.dateFilterLabel },
                          },
                          [
                            _vm.activeTab === "DAILY"
                              ? _c("el-date-picker", {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    format: "dd/MM/yyyy",
                                    placeholder: "Chọn ngày",
                                    clearable: false,
                                  },
                                  on: { change: _vm.fetchData },
                                  model: {
                                    value: _vm.searchRequest.date,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchRequest, "date", $$v)
                                    },
                                    expression: "searchRequest.date",
                                  },
                                })
                              : _vm.activeTab === "WEEKLY"
                              ? _c("el-date-picker", {
                                  staticStyle: { width: "240px" },
                                  attrs: {
                                    type: "week",
                                    "value-format": "yyyy-MM-dd",
                                    format: "Tuần WW (từ dd/MM/yyyy)",
                                    placeholder: "Chọn tuần",
                                    clearable: false,
                                  },
                                  on: { change: _vm.fetchData },
                                  model: {
                                    value: _vm.searchRequest.date,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchRequest, "date", $$v)
                                    },
                                    expression: "searchRequest.date",
                                  },
                                })
                              : _vm.activeTab === "MONTHLY"
                              ? _c("el-date-picker", {
                                  staticStyle: { width: "160px" },
                                  attrs: {
                                    type: "month",
                                    "value-format": "yyyy-MM",
                                    format: "MM/yyyy",
                                    placeholder: "Chọn tháng",
                                    clearable: false,
                                  },
                                  on: { change: _vm.fetchData },
                                  model: {
                                    value: _vm.searchRequest.date,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchRequest, "date", $$v)
                                    },
                                    expression: "searchRequest.date",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "evl-form-item",
                        attrs: { label: "Khối" },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "160px" },
                            attrs: { placeholder: "Chọn khối" },
                            on: { change: _vm.handleGradeChange },
                            model: {
                              value: _vm.searchRequest.gradeId,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchRequest, "gradeId", $$v)
                              },
                              expression: "searchRequest.gradeId",
                            },
                          },
                          _vm._l(_vm.gradeOfSchoolList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.gradeName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "evl-form-item", attrs: { label: "Lớp" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "180px" },
                            attrs: { placeholder: "Chọn lớp" },
                            on: { change: _vm.handleClassChange },
                            model: {
                              value: _vm.searchRequest.classId,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchRequest, "classId", $$v)
                              },
                              expression: "searchRequest.classId",
                            },
                          },
                          _vm._l(_vm.filteredClassList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.className, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.isPeriodicTab
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "evl-form-item",
                            attrs: { label: "Năm" },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "120px" },
                              attrs: {
                                type: "year",
                                "value-format": "yyyy",
                                format: "yyyy",
                                placeholder: "Chọn năm",
                                clearable: false,
                              },
                              on: { change: _vm.handlePeriodicYearChange },
                              model: {
                                value: _vm.periodicYear,
                                callback: function ($$v) {
                                  _vm.periodicYear = $$v
                                },
                                expression: "periodicYear",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "evl-toolbar-divider" }),
            _c(
              "div",
              {
                staticClass: "evl-toolbar-section evl-toolbar-section--action",
              },
              [
                _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
                  _c("p", { staticClass: "evl-card-title" }, [
                    _vm._v("Tác vụ"),
                  ]),
                  _c("p", { staticClass: "evl-card-subtitle" }, [
                    _vm._v(_vm._s(_vm.actionSubtitle)),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "evl-action-group flex items-center" },
                  [
                    !_vm.isPeriodicTab &&
                    _vm.selectedStudents.length > 0 &&
                    _vm.getAppTypeUserLogin === "plus"
                      ? [
                          _c("span", { staticClass: "evl-selected-count" }, [
                            _vm._v(
                              "Đã chọn " + _vm._s(_vm.selectedStudents.length)
                            ),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass: "evl-action-button",
                              attrs: {
                                type: "success",
                                plain: "",
                                icon: "el-icon-check",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleBatchApproval(true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Duyệt đã chọn\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "evl-action-button",
                              attrs: {
                                type: "warning",
                                plain: "",
                                icon: "el-icon-close",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleBatchApproval(false)
                                },
                              },
                            },
                            [_vm._v("\n              Huỷ duyệt\n            ")]
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "evl-action-button",
                        attrs: { type: "primary", icon: _vm.addBatchIcon },
                        on: { click: _vm.handleAddBatchByCurrentTab },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.addBatchButtonText) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "evl-action-button",
                        attrs: {
                          type: "success",
                          plain: "",
                          icon: "el-icon-download",
                        },
                        on: { click: _vm.handleOpenExportDialog },
                      },
                      [_vm._v("\n            Xuất Excel\n          ")]
                    ),
                    _c(
                      "el-dropdown",
                      {
                        staticClass: "evl-task-dropdown",
                        attrs: { trigger: "click" },
                        on: { command: _vm.handleAction },
                        scopedSlots: _vm._u([
                          {
                            key: "dropdown",
                            fn: function () {
                              return [
                                _c(
                                  "el-dropdown-menu",
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "evaluationConfig",
                                          icon: "el-icon-setting",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Thiết lập\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "evl-action-button",
                            attrs: { type: "primary", plain: "" },
                          },
                          [
                            _vm._v("\n              Tác vụ "),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "evl-table-card row-data" }, [
            _c("div", { staticClass: "evl-card-head evl-table-head" }, [
              _c("div", [
                _c("p", { staticClass: "evl-card-title" }, [
                  _vm._v("Danh sách nhận xét"),
                ]),
                _c("p", { staticClass: "evl-card-subtitle" }, [
                  _vm._v(_vm._s(_vm.tableSubtitle)),
                ]),
              ]),
            ]),
            _c(
              "div",
              [
                _c(
                  "el-tabs",
                  {
                    staticClass: "sk-tabs",
                    attrs: { type: "card" },
                    on: { "tab-click": _vm.handleTabChange },
                    model: {
                      value: _vm.activeTab,
                      callback: function ($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab",
                    },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { name: "DAILY" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-date" }),
                          _vm._v(" Ngày\n            "),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { name: "WEEKLY" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-document" }),
                          _vm._v(" Tuần\n            "),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { name: "MONTHLY" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-notebook-2" }),
                          _vm._v(" Tháng\n            "),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { name: "PERIODIC" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-s-claim" }),
                          _vm._v(" Định kỳ\n            "),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "evl-table-wrapper" },
              [
                !_vm.isPeriodicTab
                  ? _c("EvaluationTable", {
                      ref: "evaluationTable",
                      attrs: {
                        data: _vm.tableData,
                        loading: _vm.tableLoading,
                        "active-tab": _vm.activeTab,
                      },
                      on: {
                        view: _vm.handleViewDetail,
                        edit: _vm.handleEdit,
                        delete: _vm.handleDelete,
                        approve: _vm.handleApprove,
                        "add-for-student": _vm.handleAddForStudent,
                        "activity-log": _vm.handleActivityLog,
                        "view-files": _vm.handleViewFiles,
                        "selection-change": _vm.handleStudentSelectionChange,
                      },
                    })
                  : _vm._e(),
                _vm.isPeriodicTab
                  ? _c(
                      "div",
                      [
                        _vm.periodicSelection.length > 0
                          ? _c("div", { staticClass: "evl-periodic-toolbar" }, [
                              _c(
                                "div",
                                { staticClass: "evl-periodic-batch-actions" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "evl-periodic-selected" },
                                    [
                                      _vm._v(
                                        "Đã chọn " +
                                          _vm._s(_vm.periodicSelection.length) +
                                          " học sinh"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "success",
                                        plain: "",
                                        icon: "el-icon-check",
                                      },
                                      on: {
                                        click: _vm.handlePeriodicBatchApprove,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Duyệt đã chọn\n              "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "warning",
                                        plain: "",
                                        icon: "el-icon-close",
                                      },
                                      on: {
                                        click: _vm.handlePeriodicBatchUnapprove,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Huỷ duyệt\n              "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        plain: "",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: _vm.handlePeriodicBatchDelete,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Xoá đã chọn\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _c("PeriodicEvaluationTable", {
                          ref: "periodicTable",
                          attrs: {
                            data: _vm.periodicData,
                            loading: _vm.periodicLoading,
                          },
                          on: {
                            view: _vm.handlePeriodicView,
                            history: _vm.handlePeriodicHistory,
                            add: _vm.handlePeriodicAdd,
                            edit: _vm.handlePeriodicEdit,
                            delete: _vm.handlePeriodicDelete,
                            approve: _vm.handlePeriodicApprove,
                            "view-files": _vm.handleViewFiles,
                            "selection-change":
                              _vm.handlePeriodicSelectionChange,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm.mainTab === "CATEGORY_TEMPLATES"
        ? _c(
            "div",
            [
              _c("EvaluationCategorySettingsPage", {
                attrs: { "is-embedded": true },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("EvaluationDailyFormDialog", {
        ref: "dailyDialog",
        attrs: {
          "class-id": _vm.searchRequest.classId,
          date: _vm.searchRequest.date,
          "student-list": _vm.studentListFromTable,
        },
        on: { saved: _vm.fetchData },
      }),
      _c("EvaluationDailyBatchFormDialog", {
        ref: "dailyBatchDialog",
        attrs: { date: _vm.searchRequest.date },
        on: { saved: _vm.handleDailyBatchSaved },
      }),
      _c("EvaluationPeriodBatchFormDialog", {
        ref: "weeklyBatchDialog",
        attrs: { period: "WEEKLY", date: _vm.searchRequest.date },
        on: { saved: _vm.handlePeriodBatchSaved },
      }),
      _c("EvaluationPeriodBatchFormDialog", {
        ref: "monthlyBatchDialog",
        attrs: { period: "MONTHLY", date: _vm.searchRequest.date },
        on: { saved: _vm.handlePeriodBatchSaved },
      }),
      _c("EvaluationWeeklyFormDialog", {
        ref: "weeklyDialog",
        attrs: {
          "class-id": _vm.searchRequest.classId,
          date: _vm.searchRequest.date,
          "student-list": _vm.studentListFromTable,
        },
        on: { saved: _vm.fetchData },
      }),
      _c("EvaluationMonthlyFormDialog", {
        ref: "monthlyDialog",
        attrs: {
          "class-id": _vm.searchRequest.classId,
          date: _vm.searchRequest.date,
          "student-list": _vm.studentListFromTable,
        },
        on: { saved: _vm.fetchData },
      }),
      _c("EvaluationDetailDialog", {
        ref: "detailDialog",
        attrs: {
          "class-id": _vm.searchRequest.classId,
          date: _vm.searchRequest.date,
        },
        on: { updated: _vm.fetchData },
      }),
      _c("EvaluationActivityLogDialog", {
        ref: "activityLogDialog",
        attrs: {
          "class-id": _vm.searchRequest.classId,
          periodic: _vm.isPeriodicTab,
          year: _vm.periodicYear,
        },
      }),
      _c("EvaluationFilePreviewDialog", { ref: "filePreviewDialog" }),
      _c("EvaluationConfigDialog", {
        ref: "evaluationConfigDialog",
        attrs: { "dialog-visible": _vm.evaluationConfigDialogVisible },
        on: {
          "dialog-close": function ($event) {
            _vm.evaluationConfigDialogVisible = false
          },
        },
      }),
      _c("EvaluationExportDialog", {
        ref: "exportDialog",
        attrs: {
          "class-info": _vm.currentClassInfo,
          "class-id": _vm.searchRequest.classId,
        },
      }),
      _c("PeriodicEvaluationDetailDialog", {
        ref: "periodicDetailDialog",
        attrs: { year: _vm.periodicYear },
        on: {
          edit: _vm.handlePeriodicEditFromDetail,
          delete: _vm.handlePeriodicDeleteFromDetail,
          approve: _vm.handlePeriodicApproveFromDetail,
          "add-period": _vm.handlePeriodicAddPeriodFromDetail,
          updated: _vm.handlePeriodicDetailUpdated,
        },
      }),
      _c("PeriodicEvaluationFormDialog", {
        ref: "periodicFormDialog",
        attrs: {
          "class-id": _vm.searchRequest.classId,
          "class-name": _vm.currentClassName,
          "grade-id": _vm.searchRequest.gradeId,
          year: _vm.periodicYear,
        },
        on: { saved: _vm.handlePeriodicSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
      _c("p", { staticClass: "evl-card-title" }, [_vm._v("Nhận xét học sinh")]),
      _c("p", { staticClass: "evl-card-subtitle" }, [
        _vm._v("Quản lý nhận xét theo ngày, tuần, tháng cho từng lớp"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }